<template>
    <modal-crud
        :title=title
        v-on:close="$emit('close')"
        :isLoading=isLoading>
        <section class="modal-card-body">
            <b-field label="Nome">
                <b-input
                    type="text"
                    placeholder="Nome"
                    v-model="ambiente"
                    required>
                </b-input>
            </b-field>
        </section>
        <div slot="buttons">
            <b-button
                label="Salvar"
                type="is-primary"
                @click="save" />
        </div>
    </modal-crud>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import ModalCrud from '@/components/Layout/ModalCrud.vue';
import state from '@/modules/auth/store/state';
import services from '@/http';

@Component({
    components: {
        "modal-crud":ModalCrud,
    },
})

export default class Create extends Vue { 
    @Prop({default: {}}) aplicacao
    @Prop({default: ''}) title

    data() {
        return {
            ambiente: null,
            isLoading: false
        }
    }

    save() {
        var data = {
            aplicacao_id: this.aplicacao.AplicacaoID,
            ambiente: this.ambiente,
            userId: state.user.id            
        }

        this.isLoading = true;

        services.ambiente.register(data)
            .then(res => {
                this.$root.flashSuccess('Adicionado com sucesso!')

                this.$emit('close');               
                this.$emit('refreshList');               
            })
            .catch(err => {
                this.$root.flashError(err)
            })
            .finally(()=>{
                this.isLoading = false;
            });
    }
}
</script>